import React from "react";
import classnames from "classnames";
import { Body, BodyHighlight } from "@ddm-design-system/typography";
import "./product-card.scss";

interface IProductBeverageDataItem {
  isVertical?: boolean;
  withBorder?: boolean;
  label: string;
}

const ProductBeverageDataItem: React.FC<IProductBeverageDataItem> = ({
  children,
  isVertical = false,
  withBorder = false,
  label
}) => (
  <div
    className={classnames(
      "product-beverage-data-item",
      isVertical && "product-beverage-data-item--vertical",
      withBorder && "product-beverage-data-item--with-border"
    )}
  >
    <Body className="product-beverage-data-label">{label}</Body>
    <BodyHighlight>{children}</BodyHighlight>
  </div>
);

export default ProductBeverageDataItem;
